import { render } from "./CustomBreadcrumb.vue?vue&type=template&id=5a5ef158&scoped=true"
import script from "./CustomBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CustomBreadcrumb.vue?vue&type=script&lang=js"

import "./CustomBreadcrumb.vue?vue&type=style&index=0&id=5a5ef158&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5ef158"]])

export default __exports__